<template>
  <v-form enctype="multipart/form-data" ref="form_certificate" lazy-validation>
    <v-layout>
      <v-row class="mt-4">
        <v-col cols="12" md="4">
          <app-cb
            cb_type="profile"
            cb_url="apiListProfile"
            cb_url_parameter="profile_actived=Y"
            cb_title="Obligie"
            cb_id="cert_obligie"
            cb_desc="cert_obligiedesc"
            cb_rules="Please fill Obligie"
            cb_desc_readonly="readonly"
            cb_items_id="profile_id"
            cb_items_desc="profile_name"
            class="ml-2 mr-0"
            :cb_value_id="this.form.cert_obligie"
            :cb_value_desc="this.form.cert_obligiedesc"
            @clicked="GetObligie"
          >
          </app-cb>
        </v-col>

        <v-col cols="12" md="4">
          <app-cb
            cb_type="profile"
            cb_url="apiListProfile"
            cb_url_parameter="profile_actived=Y"
            cb_title="Principle"
            cb_id="cert_principle"
            cb_desc="cert_principledesc"
            cb_rules="Please fill Principle"
            cb_desc_readonly="readonly"
            cb_items_id="profile_id"
            cb_items_desc="profile_name"
            class="mx-0"
            :cb_value_id="this.form.cert_principle"
            :cb_value_desc="this.form.cert_principledesc"
            @clicked="GetPrinciple"
          >
          </app-cb>
        </v-col>
        <v-col cols="12" sm="2" md="2" class="mt-n3">
          <v-dialog
            ref="dialog_cert_sdate"
            v-model="modal.cert_sdate"
            :return-value.sync="form.cert_sdate"
            width="290px"
            persistent
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.cert_sdate"
                label="Period Policy Start"
                prepend-inner-icon="mdi-calendar-range"
                background-color="date"
                v-on="on"
                v-mask="'####-##-##'"
                placeholder="YYYY-MM-DD"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.cert_sdate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal.cert_sdate = false"
                >Cancel</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="$refs.dialog_cert_sdate.save(form.cert_sdate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="12" sm="2" md="2" class="mt-n3">
          <v-dialog
            ref="dialog_cert_edate"
            v-model="modal.cert_edate"
            :return-value.sync="form.cert_edate"
            width="290px"
            persistent
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.cert_edate"
                label="Period Policy End"
                prepend-inner-icon="mdi-calendar-range"
                background-color="date"
                v-on="on"
                v-mask="'####-##-##'"
                placeholder="YYYY-MM-DD"
                class="mr-2"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.cert_edate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal.cert_edate = false"
                >Cancel</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="$refs.dialog_cert_edate.save(form.cert_edate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" md="4">
          <app-cb
            cb_type="code"
            cb_url="apiListCode"
            cb_url_parameter="code_group=OPEX&code_actived=Y"
            cb_title="Type Of Project"
            cb_id="cert_typeofproject"
            cb_desc="cert_typeofprojectdesc"
            cb_rules="Please fill Type Of Project"
            cb_desc_readonly="readonly"
            cb_items_id="code_id"
            cb_items_desc="code_desc"
            class="ml-2 mr-0"
            :cb_value_id="this.form.cert_typeofproject"
            :cb_value_desc="this.form.cert_typeofprojectdesc"
            @clicked="GetTOP"
          >
          </app-cb>
        </v-col>
        <v-col cols="12" md="4" class="mt-n3">
          <v-text-field
            v-model="form.cert_projectname"
            label="Project Name"
            prepend-inner-icon="mdi-file-document-outline"
            :required="true"
          />
        </v-col>
        <v-col cols="12" md="4" class="mt-n3">
          <v-text-field
            v-model="form.cert_projectlocation"
            label="Project Location"
            prepend-inner-icon="mdi-map-marker-outline"
            class="mr-2"
            :required="true"
          />
        </v-col>

        <v-col cols="12" md="4">
          <app-cb
            cb_type="code"
            cb_url="apiListCode"
            cb_url_parameter="code_group=CLAIMDOCAKH&code_actived=Y"
            cb_title="Document"
            cb_id="cert_document"
            cb_desc="cert_documentdesc"
            cb_rules="Please fill Document"
            cb_desc_readonly="readonly"
            cb_items_id="code_id"
            cb_items_desc="code_desc"
            class="ml-2 mr-0"
            :cb_value_id="this.form.cert_document"
            :cb_value_desc="this.form.cert_documentdesc"
            @clicked="GetDoc"
          >
          </app-cb>
        </v-col>

        <v-col cols="12" md="3" class="mt-n3">
          <vuetify-money
            v-model="form.cert_total_contract"
            v-bind:options="format_money"
            label="Total Contract Value"
            placeholder="Total Contract Value"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding"
          />
        </v-col>

        <!-- Period Contract Start Date -->
        <v-col cols="12" sm="2" md="2" class="mt-n3">
          <v-dialog
            ref="dialog_cert_contract_sdate"
            v-model="modal.cert_contract_sdate"
            :return-value.sync="form.cert_contract_sdate"
            width="290px"
            persistent
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.cert_contract_sdate"
                label="Period Contract Start"
                prepend-inner-icon="mdi-calendar-range"
                background-color="date"
                v-on="on"
                v-mask="'####-##-##'"
                placeholder="YYYY-MM-DD"
                @input="handleDateChange"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.cert_contract_sdate"
              scrollable
              @change="handleDateChange"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="modal.cert_contract_sdate = false"
                >Cancel</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="
                  $refs.dialog_cert_contract_sdate.save(
                    form.cert_contract_sdate
                  );
                  handleDateChange();
                "
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>

        <!-- Period Contract End Date -->
        <v-col cols="12" sm="2" md="2" class="mt-n3">
          <v-dialog
            ref="dialog_cert_contract_edate"
            v-model="modal.cert_contract_edate"
            :return-value.sync="form.cert_contract_edate"
            width="290px"
            persistent
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="form.cert_contract_edate"
                label="Period Contract End"
                prepend-inner-icon="mdi-calendar-range"
                background-color="date"
                v-on="on"
                v-mask="'####-##-##'"
                placeholder="YYYY-MM-DD"
                @input="handleDateChange"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.cert_contract_edate"
              scrollable
              @change="handleDateChange"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="modal.cert_contract_edate = false"
                >Cancel</v-btn
              >
              <v-btn
                text
                color="primary"
                @click="
                  $refs.dialog_cert_contract_edate.save(
                    form.cert_contract_edate
                  );
                  handleDateChange();
                "
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>

        <!-- Tenor Field -->
        <v-col cols="12" md="1" class="mt-n3">
          <vuetify-money
            :value="form.cert_tenor"
            v-bind:options="format_money"
            label="Tenor"
            placeholder="Tenor"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding mr-2"
            readonly
          />
        </v-col>
        <v-col cols="12" md="4">
          <app-cb
            cb_type="riskcov"
            cb_url="apiListRiskCov"
            cb_url_parameter="riskcov_actived=Y"
            cb_title="Risk Coverage"
            cb_id="cert_risk_cov"
            cb_desc="cert_risk_cov_desc"
            cb_rules="Please fill Risk Coverage"
            cb_desc_readonly="readonly"
            cb_items_id="riskcov_id"
            cb_items_desc="riskcov_desc"
            class="ml-2 mr-0"
            :cb_value_id="this.form.cert_risk_cov"
            :cb_value_desc="this.form.cert_risk_cov_desc"
            @clicked="GetRiskCov"
          >
          </app-cb>
        </v-col>

        <v-col cols="12" md="3" class="mt-n3">
          <vuetify-money
            v-model="form.cert_guarantee_value"
            v-bind:options="format_money"
            label="Guarantee Value"
            placeholder="Guarantee Value"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding"
            @input="CalculateGuaranteeFee"
          />
        </v-col>
        <v-col cols="12" md="1" class="mt-n3 ">
          <vuetify-money
            v-model="form.cert_rate"
            v-bind:options="format_money"
            label="Rate"
            placeholder="Rate"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding"
            @input="CalculateGuaranteeFee"
          />
        </v-col>
        <v-col cols="12" md="2" class="mt-n3">
          <vuetify-money
            v-model="form.cert_guarantee_fee"
            v-bind:options="format_money"
            label="Guarantee Fee"
            placeholder="Guarantee Fee"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding"
            readonly
            @change="CalculateTotal"
          />
        </v-col>

        <v-col cols="12" md="1" class="mt-n3">
          <vuetify-money
            v-model="form.cert_policy_fee"
            v-bind:options="format_money"
            label="Certificate Fee"
            placeholder="Certificate Fee"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding"
            @input="CalculateTotal"
          />
        </v-col>
        <v-col cols="12" md="1" class="mt-n3 ">
          <vuetify-money
            v-model="form.cert_stamp_duty"
            v-bind:options="format_money"
            label="Stamp Duty"
            placeholder="Stamp Duty"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding mr-2"
            @input="CalculateTotal"
          />
        </v-col>

        <v-col cols="12" md="4" class="mt-n3">
          <v-text-field
            v-model="form.cert_ceoname"
            label="CEO Name"
            prepend-inner-icon="mdi-account-outline"
            class="ml-2"
            :rules="[v => !!v || 'CEO Name is required']"
            required
          />
        </v-col>
        <v-col cols="12" md="4" class="mt-n3">
          <v-text-field
            v-model="form.cert_commission_name"
            label="Commission Name"
            prepend-inner-icon="mdi-account-cash-outline"
            :rules="[v => !!v || 'Commission Name is required']"
            required
          />
        </v-col>
        <v-col cols="12" md="4" class="mt-n3">
          <vuetify-money
            v-model="form.cert_total"
            v-bind:options="format_money"
            label="Total"
            placeholder="Total"
            background-color="numeric"
            v-bind:properties="properties"
            class="custom-input-padding mr-2"
          />
        </v-col>

        <v-col cols="12" sm="12" md="12" class="mt-n3">
          <label class="caption ml-2">Remarks</label>
          <quill-editor
            ref="cert_remarks"
            v-model="form.cert_remarks"
            class="mx-2"
          >
          </quill-editor>
        </v-col>
        <v-col cols="12">
          <v-btn
            class="ml-2 mb-2"
            small
            color="primary"
            @click="Confirm('write', '')"
          >
            Submit
          </v-btn>
          <v-btn class="ml-2 mb-2" small color="error" @click="ClearFrom()">
            Clear Form
          </v-btn>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar.dialog"
        :timeout="snackbar.timeout"
        color="fourth"
        rounded="pill"
        top
        style="z-index: 9999"
      >
        {{ snackbar.text }}
        <template>
          <v-btn
            dark
            text
            @click.native="remarks.dialog = true"
            small
            v-if="snackbar.color === 'error'"
            >Open</v-btn
          >
          <v-btn dark text @click.native="snackbar.dialog = false" small
            >Close</v-btn
          >
        </template>
      </v-snackbar>
      <v-dialog
        v-model="confirm.dialog"
        max-width="490"
        hide-overlay
        persistent
      >
        <v-card>
          <v-card-title class="teal white--text"
            >{{ confirm.title }}?</v-card-title
          >
          <v-card-text></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              id="dialog"
              color="primary"
              small
              :disabled="confirm.text === 'Ok' ? false : true"
              @click="Action"
              >{{ confirm.text }}
            </v-btn>
            <v-btn color="error" small @click="confirm.dialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-form>
</template>
<style scoped>
/* Scoped style with specific targeting */
::v-deep .custom-input-padding .v-text-field__slot input {
  padding-right: 5px;
  font-weight: bold;
  color: black;
}
</style>
<script>
export default {
  data: () => ({
    modal: {
      cert_sdate: false,
      cert_edate: false
    },
    snackbar: {
      dialog: false,
      color: "success",
      text: "",
      timeout: 3000
    },
    remarks: {
      feedback: "",
      dialog: false
    },
    item: [],
    form: {
      cert_obligie: "",
      cert_obligiedesc: "",
      cert_principle: "",
      cert_principledesc: "",
      cert_sdate: "",
      cert_edate: "",
      cert_typeofproject: "",
      cert_typeofprojectdesc: "",
      cert_projectname: "",
      cert_projectlocation: "",
      cert_risk_cov: "",
      cert_risk_cov_desc: "",
      cert_total_contract: 0,
      cert_contract_sdate: "",
      cert_contract_edate: "",
      cert_rate: 0,
      cert_tenor: 0,
      cert_guarantee_value: 0,
      cert_guarantee_fee: 0,
      cert_policy_fee: 0,
      cert_stamp_duty: 0,
      cert_total: 0,
      cert_policy_sdate: "",
      cert_policy_edate: "",
      policy_policyno: "",
      policy_certificateno: "",
      cert_ceoname: "",
      cert_commission_name: "",
      insured: ""
    },
    confirm: {
      dialog: false,
      title: "",
      text: "Ok",
      send: false,
      sendtitle: "",
      sendtext: "Ok"
    },
    properties: {
      reverse: true
    },
    format_money: {
      decimal: ",",
      thousands: ".",
      precision: 0
    },
    loading: {
      detail: false
    }
  }),
  created() {
    this.form.cert_sdate = this.$functions.TodayYYYYMMDD();
    this.form.cert_edate = this.$functions.TodayYYYYMMDD();
    this.form.cert_contract_sdate = this.$functions.TodayYYYYMMDD();
    this.form.cert_contract_edate = this.$functions.TodayYYYYMMDD();
  },
  watch: {
    "form.cert_guarantee_fee"(newVal) {
      this.CalculateTotal(newVal);
    }
  },
  methods: {
    Confirm(flag) {
      if (flag === "write") {
        if (this.$refs.form_certificate.validate()) {
          this.url_type = "add";
          this.confirm.dialog = true;
          this.confirm.title = "Create Certificate";
          setTimeout(function() {
            document.getElementById("dialog").focus();
          }, 500);
        }
      }
    },
    SnackBar(dialog, color, text, timeout) {
      this.snackbar = {
        dialog: dialog,
        color: color,
        text: text,
        timeout: timeout
      };
      if (color === "error") {
        this.confirm.dialog = false;
        this.confirm.text = "Ok";
      }
    },
    handleDateChange() {
      // Convert to Date objects
      const startDate = new Date(this.form.cert_contract_sdate);
      const endDate = new Date(this.form.cert_contract_edate);
      // Validate if end date is before start date
      if (endDate < startDate) {
        this.form.cert_contract_edate = this.form.cert_contract_sdate; // or another handling logic
      } else if (startDate > endDate) {
        this.form.cert_contract_sdate = this.form.cert_contract_edate; // or another handling logic
      }
      this.CalculateTenor();
    },
    GetObligie(value) {
      if (value !== undefined) {
        let splits = this.$functions.Split(value, "|");
        let profileid = splits[0];
        let profiledesc = splits[1];
        this.form.cert_obligie = profileid;
        this.form.cert_obligiedesc = profiledesc;
      }
    },
    GetPrinciple(value) {
      if (value !== undefined) {
        let splits = this.$functions.Split(value, "|");
        let profileid = splits[0];
        let profiledesc = splits[1];
        this.form.cert_principle = profileid;
        this.form.cert_principledesc = profiledesc;
        console.log(splits);
      }
    },
    GetTOP(value) {
      if (value !== undefined) {
        let splits = this.$functions.Split(value, "|");
        let code_id = splits[0];
        let code_desc = splits[1];
        this.form.cert_typeofproject = code_id;
        this.form.cert_typeofprojectdesc = code_desc;
      }
    },
    GetDoc(value) {
      if (value !== undefined) {
        let splits = this.$functions.Split(value, "|");
        let code_id = splits[0];
        let code_desc = splits[1];
        this.form.cert_document = code_id;
        this.form.cert_documentdesc = code_desc;
      }
    },
    GetRiskCov(value) {
      if (value !== undefined) {
        let splits = this.$functions.Split(value, "|");
        let riskcov_id = splits[0];
        let riskcov_desc = splits[1];
        this.form.cert_risk_cov = riskcov_id;
        this.form.cert_risk_cov_desc = riskcov_desc;
      }
    },
    CalculateTenor() {
      if (this.form.cert_contract_sdate && this.form.cert_contract_edate) {
        const startDate = new Date(this.form.cert_contract_sdate);
        const endDate = new Date(this.form.cert_contract_edate);
        const yearsDifference = endDate.getFullYear() - startDate.getFullYear();
        const monthsDifference = endDate.getMonth() - startDate.getMonth();
        const totalMonths = yearsDifference * 12 + monthsDifference;
        this.form.cert_tenor = totalMonths >= 0 ? totalMonths : 0;
      } else {
        this.form.cert_tenor = 0;
      }
    },
    CalculateGuaranteeFee() {
      this.form.cert_guarantee_fee =
        (this.form.cert_guarantee_value * this.form.cert_rate) / 100;
    },
    CalculateTotal() {
      this.form.cert_total =
        (parseFloat(this.form.cert_guarantee_fee) || 0) +
        (parseFloat(this.form.cert_policy_fee) || 0) +
        (parseFloat(this.form.cert_stamp_duty) || 0);
    },
    ClearFrom() {
      this.form.cert_obligie = "";
      this.form.cert_obligiedesc = "";
      this.form.cert_principle = "";
      this.form.cert_principledesc = "";
      this.form.cert_sdate = this.$functions.TodayYYYYMMDD();
      this.form.cert_edate = this.$functions.TodayYYYYMMDD();
      this.form.cert_contract_sdate = this.$functions.TodayYYYYMMDD();
      this.form.cert_contract_edate = this.$functions.TodayYYYYMMDD();
      this.form.cert_typeofproject = "";
      this.form.cert_typeofprojectdesc = "";
      this.form.cert_projectname = "";
      this.form.cert_projectlocation = "";
      this.form.cert_risk_cov = "";
      this.form.cert_risk_cov_desc = "";
      this.form.cert_total_contract = 0;
      this.form.cert_rate = 0;
      this.form.cert_tenor = 0;
      this.form.cert_guarantee_value = 0;
      this.form.cert_guarantee_fee = 0;
      this.form.cert_policy_fee = 0;
      this.form.cert_stamp_duty = 0;
      this.form.cert_total = 0;
      this.form.cert_policy_sdate = "";
      this.form.cert_policy_edate = "";
      this.form.policy_policyno = "";
      this.form.policy_certificateno = "";
      this.form.cert_ceoname = "";
      this.form.cert_commission_name = "";
      this.form.insured = "";
    },
    Action() {
      this.confirm.text = "Loading...";
      if (this.url_type === "add") {
        const formData = new FormData();
        formData.append("url_type", this.url_type);
        formData.append("fastflow_type", "N");
        formData.append("fastflow_insured", this.form.cert_principledesc);
        formData.append("fastflow_signdate", this.$functions.TodayYYYYMMDD());
        formData.append("fastflow_branch", "01");
        formData.append("fastflow_branchdate", this.$functions.TodayYYYYMMDD());
        formData.append("fastflow_branchby", this.$functions.UsersID());
        formData.append("fastflow_sourcedate", this.$functions.TodayYYYYMMDD());
        formData.append("fastflow_profile_holderid", this.form.cert_obligie);
        formData.append("fastflow_profile_insuredid", this.form.cert_principle);
        formData.append("fastflow_sdate", this.form.cert_sdate);
        formData.append("fastflow_edate", this.form.cert_edate);
        formData.append(
          "fastflow_fieldvaluedesc_1",
          this.form.cert_typeofproject
        );
        formData.append(
          "fastflow_fieldvaluedesc_2",
          this.form.cert_projectname
        );
        formData.append(
          "fastflow_fieldvaluedesc_3",
          this.form.cert_projectlocation
        );
        formData.append("fastflow_fieldvaluedesc_4", this.form.cert_ceoname);
        formData.append(
          "fastflow_fieldvaluedesc_5",
          this.form.cert_commission_name
        );
        formData.append(
          "fastflow_fieldvaluedesc_6",
          this.form.cert_total_contract
        );
        formData.append(
          "fastflow_fieldvaluedesc_7",
          this.form.cert_contract_sdate
        );
        formData.append(
          "fastflow_fieldvaluedesc_8",
          this.form.cert_contract_edate
        );
        formData.append("fastflow_fieldvaluedesc_9", this.form.cert_document);
        formData.append("fastflow_tsi", this.form.cert_guarantee_value);
        formData.append("fastflow_main_cont", this.form.cert_guarantee_fee);
        formData.append("fastflow_feeduty", this.form.cert_policy_fee);
        formData.append("fastflow_stampduty", this.form.cert_stamp_duty);
        formData.append("fastflow_total", this.form.cert_total);
        formData.append("fastflow_main_type", this.form.cert_risk_cov);
        formData.append("fastflow_main_interest", "");
        formData.append("fastflow_periodunit", "M");
        formData.append("fastflow_period", this.form.cert_tenor);
        formData.append("fastflow_remark", this.form.cert_remark);
        formData.append("fastflow_group", "SURETY");
        formData.append("fastflow_toc", "6401");
        // let param = this.$functions.ParamPOST(formdata);
        this.$axios
          .post(this.$functions.SafeURL("apiWriteFastFlow"), formData, {
            headers: {
              "Content-Type": "text/plain; charset=ISO-8859-1"
            }
          })
          .then(response => {
            let feedback = response.data;
            if (feedback.length > 0) {
              if (feedback[0].feedback === "Y") {
                setTimeout(() => {
                  this.SnackBar(true, "success", "Save Success", 3000);
                }, 500);
                this.confirm.dialog = false;
                this.confirm.text = "Ok";
                this.url_type = "edit";
                this.$emit("response", feedback[0]);
                this.ClearFrom();
              } else {
                this.SnackBar(true, "error", this.$functions.ErrorCode(), 0);
                this.remarks.dialog = true;
                this.remarks.feedback = feedback[0].feedback;
              }
            } else {
              this.SnackBar(true, "error", this.$functions.ErrorCode(), 0);
              this.remarks.dialog = true;
              this.remarks.feedback = feedback;
            }
          })
          .catch(e => {
            this.SnackBar(true, "error", this.$functions.ErrorCode(), 0);
            this.remarks.dialog = true;
            this.remarks.feedback = e;
          });
      }
    }
  }
};
</script>
